import classNames from 'classnames';
import { ButtonsGroup } from 'components/shared/ButtonsGroup/ButtonsGroup';
import { FC, useCallback, useMemo } from 'react';
import type { PriceImprovementExpirationTime } from 'state/quotes/priceEnhancements/priceImprovementRequest/priceImprovementRequest.model';

type Option = PriceImprovementExpirationTime | 'None';

const availableOptions: Option[] = ['ThreeMinutes', 'OneHour', 'None'];

interface Props {
  value: Nullable<PriceImprovementExpirationTime>;
  onSelect: (value: Nullable<PriceImprovementExpirationTime>) => void;
  className?: string;
  e2e?: string;
}

export const ExpirationTimeSelector: FC<Props> = ({ value, className, e2e, onSelect }) => {
  const selectedItem = useMemo(() => (value ? value : 'None'), [value]);

  const _onSelect = useCallback((option: Option) => onSelect(option === 'None' ? null : option), [onSelect]);

  return (
    <ButtonsGroup
      className={classNames('w-100', className)}
      items={availableOptions}
      selectedItems={selectedItem}
      translationPrefix="priceImprovement.expirationTime"
      onSelect={items => _onSelect(items[0])}
      isRadio
      e2e={e2e}
    />
  );
};
